import { createContext, useContext } from 'react';

interface SolanaContextValue {
  chainId: number;
}

export const SolanaContext = createContext<SolanaContextValue>({
  chainId: 900900900,
});

export function useSolanaChain() {
  return useContext(SolanaContext);
}
